import React from "react";
import {
  View,
  Image,
  StyleSheet,
  Platform,
  useWindowDimensions,
} from "react-native";

/** Faint monochrome Uluru silhouette — watermark only, no colour fill */
const WATERMARK_OPACITY = 0.1;

const ULURU_ASPECT = 320 / 1600; // height / width from uluru-watermark.png

const uluruWatermark = require("../assets/brand/uluru-watermark.png");

const OutbackWatermark = ({ visible = true }) => {
  const { width } = useWindowDimensions();
  const watermarkWidth = Math.min(Math.max(width * 0.96, 320), 680);
  const watermarkHeight = Math.round(watermarkWidth * ULURU_ASPECT);

  if (!visible) {
    return null;
  }

  return (
    <View
      style={styles.container}
      pointerEvents="none"
      accessibilityElementsHidden
      importantForAccessibility="no-hide-descendants"
    >
      <Image
        source={uluruWatermark}
        style={[
          styles.image,
          {
            width: watermarkWidth,
            height: watermarkHeight,
            opacity: WATERMARK_OPACITY,
          },
        ]}
        resizeMode="contain"
        accessible={false}
        accessibilityIgnoresInvertColors
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: Platform.OS === "web" ? "fixed" : "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    alignItems: "center",
    justifyContent: "flex-end",
    zIndex: 1,
    pointerEvents: "none",
  },
  image: {
    marginBottom: Platform.OS === "web" ? 10 : 6,
  },
});

export default OutbackWatermark;
